import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import { MARKETING } from 'self-service-api/constants/ProductLines';
import { useAppSelector } from '../../../reducers';
import { hasProductsInProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { hasAnyTBSkuInProductDataSelector, productForSkuIdSelector, skuIdIsHubSelector } from '../../../selectors/ProductsSelectors';

/**
 * A portal is eligible for the Free to Pro touchless flow if:
 * - It's a free portal
 * - They're purchasing a single hub at the Pro tier
 * - That single hub is not Marketing
 * @param productConfigurations
 * @returns
 */
const useIsEligibleForFreeToProTouchlessFlow = productConfigurations => useAppSelector(state => {
  const isSeatsTBPortal = hasAnyTBSkuInProductDataSelector(state);
  const isPaidPortal = hasProductsInProductInventorySelector(state);
  if (isPaidPortal || !isSeatsTBPortal) return false;
  const hubProductConfigs = productConfigurations.filter(config => skuIdIsHubSelector(state, {
    skuId: config.skuId
  }));
  if (hubProductConfigs.length !== 1) {
    return false;
  }
  const hubProductConfig = hubProductConfigs[0];
  const product = productForSkuIdSelector(state, {
    skuId: hubProductConfig.skuId
  });
  return product && product.productLine !== MARKETING && product.productLevel === PROFESSIONAL;
});
export default useIsEligibleForFreeToProTouchlessFlow;